import { Button } from 'components/Form'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Error() {
    const navigate = useNavigate()

    return (
        <div className="flex items-center justify-center h-screen">
            <div className="text-center">
                <h1 className="text-4xl font-bold">Oops! 404</h1>
                <p className="text-lg">
                    We can't find the page you're looking for.
                </p>
                <div className="flex justify-center p-2">
                    <Button
                        className="text-white bg-primary"
                        onClick={() => navigate('/')}
                    >
                        Back to Home
                    </Button>
                </div>
            </div>
        </div>
    )
}
